/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import { PageIcon } from '@/types';
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
const colors = {
  true: 'green',
  wrong: 'red',
  empty: '',
  notKnown: 'gray',
};
const setAsTrue = (item: any) => {
  item.set('isChecked', true);
  item._objects[0].set('fill', colors.true);
};
const setAsEmpty = (item: any) => {
  item.set('isChecked', false);
  item._objects[0].set('fill', colors.empty);
};
const setAsNotKnown = (item: any) => {
  item.set('isChecked', true);
  item._objects[0].set('fill', colors.notKnown);
};
const setAsWrong = (item: any) => {
  item.set('isChecked', true);
  item._objects[0].set('fill', colors.wrong);
};
const getItem = (text: any, left: any, top: any, index: any, isCorrect: any, optionId: any, buttonSize: any) => {
  const width = buttonSize;
  const height = buttonSize;
  const c = new fabric.Rect({
    strokeWidth: 1,
    opacity: 1,
    stroke: 'darkblue',
    strokeDashArray: [1, 1],
    rx: buttonSize * 0.2,
    ry: buttonSize * 0.2,
    width,
    height,
    fill: '',
    left,
    top,
  });

  const t = new fabric.Text(text, {
    fontFamily: 'Calibri',
    fontSize: buttonSize * 0.8,
    textAlign: 'center',
    originX: 'center',
    originY: 'center',
    left: left + width / 2,
    top: top + height / 2,
  });

  const g = new fabric.Group([c, t], {
    id: `source-${text}-${index}`,
    name: `source-${text}-${index}`,
    index,
    erasable: false,
    selectable: false,
    hasControls: false,
    hasBorders: false,
    pageIcon: true,
    fill: 'darkblue',
    isCorrect,
    optionId,
    isChecked: false,
    hoverCursor: 'pointer',
  });

  return g;
};
class TrueFalse extends FabricCanvasExercise {
  private options: PageIcon[] = []; // Kaynak veriler

  configureCanvas(props: Props) {
    const canvas = this._canvas;
    const parentThis = this;
    const sources = [];
    if (props.currentPageItem.sources) {
      this.options = props.currentPageItem.sources;
    }
    const hasCompleteButton = props.currentPageItem.hasCompleteButton;
    const defaultOptions = ['T', 'F'];
    const customOptions =
      props.currentPageItem.customOptions !== undefined
        ? props.currentPageItem.customOptions.split(',')
        : defaultOptions;
    let index = 0;
    const imagePosition= canvas.getBackgroundImageCoordinate();
    for (const option of this.options) {
      let left = option.x + imagePosition.imgLeft;
      const baseTop =option.y + imagePosition.imgTop;
      const correctAnswer =
        option.correctAnswer ?? (option.isCorrect ? 'T' : 'F');
      const buttonSize =
        (option.width / customOptions.length -
          (customOptions.length - 1) * 2.5)
      const top =
        baseTop +
        (option.height -
          buttonSize) /
          2;
        for (const text of customOptions) {
          const s = getItem(
            text,
            left,
            top,
            index,
            text.toUpperCase() === correctAnswer.toUpperCase(),
            option.id,
            buttonSize,
          );
          left += buttonSize + 5;
          sources.push(s);
          canvas.addObject(s);
        }
      index++;
    }
    sources.forEach(function (source) {
      source.on('mousedown:before', (o: any) => {
        canvas.closeDrawingMode();
      });

      source.on('mousedown', function () {
        parentThis.removeOtherChecks(source);
        if (!source.isChecked) {
          if (hasCompleteButton) {
            setAsNotKnown(source);
          } else {
            parentThis.playSound(source.isCorrect);
            if (source.isCorrect) {
              setAsTrue(source);
            } else {
              setAsWrong(source);
            }
            parentThis.addOpenedAnswers(source.optionId);
          }
        } else {
          setAsEmpty(source);
          parentThis.removeOpenedAnswers(source.optionId);
        }
      });
      source.on('mouseup', function () {
        canvas.openDrawingMode();
      });
    });
    // this.renderActivityFiles(props, opts);
  }
  onReset = () => {
    this.resetOpenedAnswers();
    const canvas = this._canvas;
    const allItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('source'));
    for (const item of allItems) {
      setAsEmpty(item);
    }
    canvas.canvasRenderAll();
  };
  onShowAnswer = async () => {
    this.onReset();
    const canvas = this._canvas;
    const correctItems = canvas.getObjects().filter((x) => x.isCorrect);
    for (const source of correctItems) {
      setAsTrue(source);
      this.addOpenedAnswers(source.optionId);
    }
    this.playSound('solve');
    canvas.canvasRenderAll();
  };
  onComplete() {
    const canvas = this._canvas;
    const checkedItems = canvas.getObjects().filter((x) => x.isChecked);
    for (const item of checkedItems) {
      if (item.isCorrect) {
        setAsTrue(item);
      } else {
        setAsWrong(item);
      }
    }
    canvas.canvasRenderAll();
  }
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const showedCorrectItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id &&
          x.id.includes('source') &&
          this.getOpenedAnswers().includes(x.optionId) &&
          x.isCorrect,
      );
    if (showedCorrectItems.length > 0) {
      const item = showedCorrectItems[showedCorrectItems.length - 1];
      setAsEmpty(item);
      this.removeOpenedAnswers(item.optionId);
      canvas.canvasRenderAll();
    }
  };
  onShowNextAnswer = async () => {
    const canvas = this._canvas;
    const notShowedCorrectItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id &&
          x.id.includes('source') &&
          !this.getOpenedAnswers().includes(x.optionId) &&
          x.isCorrect,
      );
    if (notShowedCorrectItems.length > 0) {
      const item = notShowedCorrectItems[0];
      setAsTrue(item);
      this.addOpenedAnswers(item.optionId);
      this.playSound('solve');
      canvas.canvasRenderAll();
    }
  };
  removeOtherChecks = async (source: any) => {
    const canvas = this._canvas;
    const otherGroupItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id &&
          x.id !== source.id &&
          x.optionId === source.optionId &&
          x.isChecked,
      );
    if (otherGroupItems.length > 0) {
      for (const item of otherGroupItems) {
        setAsEmpty(item);
        this.removeOpenedAnswers(item.optionId);
      }
      canvas.canvasRenderAll();
    }
  };
  destroy() {
    this.resetOpenedAnswers();
  }
  doMouseDown(o: any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {}
}

export default TrueFalse;
